module.exports = __webpack_public_path__ + "static/media/ARS.c31f341e.jpg";